@if ((!isEdit || isPreview) && isVisible) {
  <div class="grid-container v-pad" [formGroup]="formGroup">
    <h2>Checkout</h2>
    @if (loadingPayments$.value == false && payments != null) {
      <div>
        @if (payments?.length > 0) {
          <!--ITEM LIST-->
          @if (paymentStepNumber === paymentStepNumbers.itemList) {
            <div>
              @if (authorizationRequest) {
                <table style="width: 75%;">
                  <caption>Payments Due</caption>
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Fee</th>
                    </tr>
                  </thead>
                  @for (paymentItem of authorizationRequest.paymentInformation.paymentItems; track paymentItem) {
                    <tr>
                      <td>{{paymentItem.description}}</td>
                      <td>{{paymentItem.fee | currency}}</td>
                    </tr>
                  }
                  <tr style="border-top: 1px solid black;">
                    <td></td>
                    <td>{{cartTotal | currency:'USD': 'symbol': '1.2-2'}}</td>
                  </tr>
                </table>
              }
            </div>
          }
          <!--PAYMENT TYPE-->
          @if (paymentStepNumber === paymentStepNumbers.paymentType) {
            <div>
              <select formControlName="paymentType" (change)="paymentTypeChanged($event)">
                @for (paymentType of paymentService.paymentTypes; track paymentType) {
                  <option [ngValue]="paymentType.value">{{paymentType.name}}</option>
                }
              </select>
            </div>
          }
        } @else {
          There are no payments due for this application.
        }
      </div>
    } @else {
      Calculating payments due ... please wait...
    }
  </div>
}




<!--<pre>{{authorizationRequest | json}}</pre>-->

